<script setup lang="ts">
import { computed } from 'vue';
import { getBirthYears, getGenderTypes } from '@/javascripts/utils/inquiry_form_options';
import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  inquiryValidation: InquiryValidation,
  currentSlideIndex: number,
}>();

const birthYears = getBirthYears();
const genderTypes = getGenderTypes();

/** 名前と生まれ年のバリデーション結果 */
const invalid = computed(() => 
  props.inquiryValidation.genderTypeCd.$invalid || 
  props.inquiryValidation.birthYearCd.$invalid ||
  props.inquiryValidation.annualIncome.$invalid
);
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>生まれ年・性別・<br class="view_sp">現在の年収を教えてください</h2>
      <div class="box_form">
        <table>
          <tr>
            <th>
              生まれ年
            </th>
            <td>
              <p class="select_box">
                <select
                  v-model="inquiry.birthYearCd"
                  class="shindan_select_inner"
                  required
                >
                  <option
                    :value="null"
                    disabled
                    selected
                    style="display:none;"
                  >
                    選択してください
                  </option>
                  <option
                    v-for="birthYear in birthYears"
                    :key="birthYear.cd"
                    :value="birthYear.cd"
                  >
                    {{ birthYear.text }}
                  </option>
                </select>
              </p>
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in inquiryValidation.birthYearCd.$errors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
          <tr class="box_input box_input_btn">
            <th class="input_tit">
              性別
            </th>
            <td class="inner_input_btn">
              <div
                v-for="genderType in genderTypes"
                :key="genderType.cd"
                class="step_btn"
              >
                <label
                  class="shindan_radio_label"
                  :for="`gender_type_${genderType.cd}`"
                >
                  <input
                    :id="`gender_type_${genderType.cd}`"
                    v-model="inquiry.genderTypeCd"
                    type="radio"
                    name="gender_type_cd"
                    class="shindan_radio_input"
                    :value="genderType.cd"
                  >
                  <p>{{ genderType.text }}</p>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in inquiryValidation.genderTypeCd.$errors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
          <tr class="box_input">
            <th class="input_tit">
              現在の年収
            </th>
            <td class="box_annualincome">
              <input
                v-model="inquiry.annualIncome"
                required
                class="annualincome"
                placeholder="450"
                type="text"
                maxlength="4"
              >
              <p class="txt_annualincome">
                万円
              </p>
            </td>
          </tr>
          <tr>
            <th class="view_pc" />
            <td class="form_error">
              <p
                v-for="(error, index) in inquiryValidation.annualIncome.$errors"
                :key="index"
                class="form_errormessage"
              >
                {{ error.$message }}
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
        <div class="btn_next input_btn">
          <button
            id="ph_next_1"
            :disabled="invalid"
            class="shindan_nextbtn_area"
            :class="{
              'shindan_next_btn_off': invalid,
              'shindan_next_btn_on': !invalid
            }"
            @click.once="$emit('next')"
          >
            <span>次へ</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
